import { Text } from "~/components/Text";

type RichDescriptionProps = {
  description?: string | null;
  richDescription?: string | null;
};

const richDescriptionClassName = [
  "font-sans text-base font-normal text-butter-green break-words leading-relaxed",
  "[&_p]:mb-3 [&_p:last-child]:mb-0",
  "[&_br]:block",
  "[&_strong]:font-bold [&_b]:font-bold",
  "[&_em]:italic [&_i]:italic",
  "[&_ul]:mb-3 [&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-5",
  "[&_ol]:mb-3 [&_ol]:list-decimal [&_ol]:space-y-1 [&_ol]:pl-5",
  "[&_li]:pl-1",
  "[&_a]:text-butter-green [&_a]:underline [&_a]:underline-offset-2",
].join(" ");

export const RichDescription = ({ description, richDescription }: RichDescriptionProps) => {
  const trimmedRichDescription = richDescription?.trim();

  if (trimmedRichDescription) {
    return (
      <div
        className={richDescriptionClassName}
        dangerouslySetInnerHTML={{ __html: trimmedRichDescription }}
      />
    );
  }

  const trimmedDescription = description?.trim();
  if (!trimmedDescription) return null;

  return (
    <Text variant="secondary" size="md" className="whitespace-pre-line break-words leading-relaxed">
      {trimmedDescription}
    </Text>
  );
};
